var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"import"},[_vm._v(" 123 "),_c('ImportModal',{attrs:{"visibleModal":_vm.visibleModalImport,"accept":['.xls', '.xlsx']},on:{"onCancel":_vm.onCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }